// Angular
import { Component, HostBinding, OnInit, Input } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
// RxJS
import { filter } from "rxjs/operators";
import { TranslationService } from "../../../../../service/translation.service";
import { UserProfileService } from "../user-profile/user-profile.service";
import { ShareService } from "../../../../../../../app/shared/service/share.service";
import { StorageService } from "../../../../../../Service/storage.service";

interface LanguageFlag {
  lang: string;
  name: string;
  flag: string;
  active?: boolean;
}

@Component({
    selector: "kt-language-selector",
    templateUrl: "./language-selector.component.html",
    styleUrls: ["./language-selector.component.scss"],
    standalone: false
})
export class LanguageSelectorComponent implements OnInit {
  // Public properties
  @HostBinding("class") classes = "";
  @Input() iconType: "" | "brand";

  language: LanguageFlag;
  languages: LanguageFlag[] = [
    {
      lang: "en",
      name: "English",
      flag: "./assets/media/flags/012-uk.svg",
    },
    {
      lang: "ch",
      name: "Mandarin",
      flag: "./assets/media/flags/015-china.svg",
    },
    {
      lang: "es",
      name: "Spanish",
      flag: "./assets/media/flags/016-spain.svg",
    },
    {
      lang: "jp",
      name: "Japanese",
      flag: "./assets/media/flags/014-japan.svg",
    },
    {
      lang: "gr",
      name: "German",
      flag: "./assets/media/flags/017-germany.svg",
    },
    {
      lang: "fr",
      name: "French",
      flag: "./assets/media/flags/019-france.svg",
    },
    {
      lang: "hi",
      name: "Hindi",
      flag: "./assets/media/flags/010-india.svg",
    },
    {
      lang: "ke",
      name: "Swahili",
      flag: "./assets/media/flags/021-kenya.svg"
    },
    {
      lang: "ar",
      name: "Arabic",
      flag: "./assets/media/flags/008-saudi-arabia.svg"
    },
    {
      lang: "ta",
      name: "Tamil",
      flag: "./assets/media/flags/010-india.svg"
    },
    {
      lang: "vi",
      name: "Vietnam",
      flag: "./assets/media/flags/022-viet-nam.svg"
    }

  ];
  userId: string;
  userLanguage: any;

  /**
   * Component constructor
   *
   * @param translationService: TranslationService
   * @param router: Router
   */
  constructor(
    private translationService: TranslationService,
    private router: Router,
    private userprofileService: UserProfileService,
    private readonly shareService: ShareService,
    private readonly storageService: StorageService
  ) {
    this.userId = this.storageService.getItem('userId');
    this.shareService.castUser.subscribe(user => this.userId = user);
    this.translationService.languageChange.subscribe((lang) => {
      if (lang) {
        this.setLanguage(lang);
      }
    });
  }

  ngOnInit() {
    // this.getUserLanguage();
    this.setSelectedLanguage();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.setSelectedLanguage();
      });
  }

  setLanguage(lang: string, isFirst: boolean = false) {
    this.languages.forEach((language: LanguageFlag) => {
      if (language.lang === lang) {
        language.active = true;
        this.language = language;
        this.userId = this.storageService.getItem('userId');
        if (this.userLanguage != this.language.lang) {
          this.updateLanguage(this.language.lang, this.userId, isFirst);
        }
      } else {
        language.active = false;
      }
    });
  }
  updateLanguage(lang: any, userId: any, isFirst: any) {
    if (lang == null) return;
    if (userId == null) return;
    this.userprofileService.updateLanguageAPI(lang, userId, isFirst).subscribe((res) => {
      if (res["Success"] == true && res["Data"] != null) {
        this.getUserLanguage();
      }
    });
  }
  getUserLanguage(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.userId = this.storageService.getItem('userId');
      this.userprofileService.getUserDetailById(this.userId).subscribe(
        (response) => {
          const userData = response["Data"];
          this.userLanguage = userData.LanguageCode;
          this.translationService.setLanguage(this.userLanguage);
          resolve();
        },
        (error) => {
          console.error('Error fetching user language:', error);
          reject();
        }
      );
    });
  }

  setSelectedLanguage() {
    this.setLanguage(this.translationService.getSelectedLanguage(), true);
  }
}
